import { getRescheduleStepData } from 'components/Booking-new/utils/steps/reschedule';
import { updateStateByLocation, setCurrentStep } from 'components/Booking-new/utils/state';
import { filterLocationsByState, filterLocationsByCity } from 'components/Booking-new/utils/steps/location';

// Default params which we take out from the URL - white list for available query params.
const DEFAULT_PARAMS = ['location', 'id', 'step', 'time', 'code', 'state', 'city'];
const defaultParamsFunction = {
  step: setCurrentStep,
  location: updateStateByLocation,
  id: getRescheduleStepData,
  state: filterLocationsByState,
  city: filterLocationsByCity,
};

class URLProvider {
  constructor(availableParams = DEFAULT_PARAMS) {
    this.availableParams = availableParams;
    this.searchParams = this.getAllParamsData();
  }

  getAllParamsData() {
    const urlSearchParams = new URLSearchParams(location.search);

    return this.availableParams.reduce((paramsData, param) => {
      const searchParam = urlSearchParams.get(param);
      if (searchParam) return { ...paramsData, [param]: searchParam };

      return { ...paramsData, [param]: null };
    }, {});
  }

  updateStateByParams(params, paramsFunction, currentState) {
    const paramsKeys = Object.keys(params);
    return paramsKeys.reduce(async (_state, param) => {
      const state = await _state;
      if (typeof paramsFunction[param] !== 'undefined') {
        const updateFunction = paramsFunction[param];
        const updatedState = await updateFunction(params[param], state, param);

        return {
          ...state,
          ...updatedState,
        };
      }

      return state;
    }, currentState);
  }

  async getState(currentState, paramsFunction = defaultParamsFunction) {
    const getUpdatedState = await this.updateStateByParams(this.searchParams, paramsFunction, currentState);
    return { ...getUpdatedState };
  }
}

export default URLProvider;
